// extracted by mini-css-extract-plugin
module.exports = {"container":"LargeSticker_container__S6BTd","circle":"LargeSticker_circle__Wj00b","sticker":"LargeSticker_sticker__UBiJh"};